import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getBookingdetails = createAsyncThunk('DriverJourney/getBookingdetails', async (params) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBookingDetails', params, {mode:'cors'})

  return response.data
})
export const updateStatus = createAsyncThunk('DriverJourney/updateStatus', async (params) => {
    
  const response = await axios.post(' https://api.zasway.com:8443/Booking/UpdateBookingStatusSimple', params, {mode:'cors'})

  return response.data
})
export const updateBookingStatusArrived = createAsyncThunk('UpcomingBooking/updateBookingStatusArrived ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const currentloc = createAsyncThunk('UpcomingBooking/updateBookingStatusArrived ', async (params) => {
        
  const response = await axios.post(' https://api.zasway.com:8443/Driver/CurrentLocation', params, { mode: 'cors' })
    
  return response.data
})


export const updateBookingStatus = createAsyncThunk('UpcomingBooking/updateBookingStatus', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const UpdateProgressStatus = createAsyncThunk('UpcomingBooking/UpdateProgressStatus', async (params) => {
        
  const response = await axios.post(' https://api.zasway.com:8443/Driver/ProcessBookingEvent', params, { mode: 'cors' })
    
  return response.data
})

export const GetNextLoc = createAsyncThunk('UpcomingBooking/GetNextLoc ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/GetBookingLocations', params, { mode: 'cors' })
      
    return response.data
})

export const AddBookingJourneyProgress = createAsyncThunk('UpcomingBooking/AddBookingJourneyProgress', async (params) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/Driver/AddBookingProgress', params, {mode:'cors'})
  
    return response.data
  })
export const updateBookingStatusInProgress = createAsyncThunk('UpcomingBooking/updateBookingStatusInProgress ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const updateBookingStatusCompleted = createAsyncThunk('UpcomingBooking/updateBookingStatusCompleted ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const updateBookingStatusCancelled = createAsyncThunk('UpcomingBooking/updateBookingStatusCancelled ', async (params) => {
        
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const AddRideLocationLog = createAsyncThunk('UpcomingBooking/AddRideLocationLog ', async (params) => {
  
    const response = await axios.post(' https://api.zasway.com:8443/Booking/AddLiveLocationLog', params, { mode: 'cors' })
      
    return response.data
  })
  export const CheckLocation = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBookingLiveLocationList', params, {mode:'cors'})
   
    return response.data
  })
  export const NextTypeID = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Driver/BookingNextLocTypeID', params, {mode:'cors'})
   
    return response.data
  })
  export const startRideBooking = createAsyncThunk('UpcomingBooking/startRideBooking ', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
  })
  export const addBookingLocation = createAsyncThunk('UpcomingBooking/addBookingLocation', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBookingLiveLocationLog', params, {mode:'cors'})
   
    return response.data
  })
  
  export const getLongLat = createAsyncThunk('/DriverJourney/getLongLat',  (getlonglat) => {
     
    return {data : getlonglat}
     
    })
export const DriverJourneySlice = createSlice({
    name: 'DriverJourney',
    initialState: {
        data: [],
        JEventTypeID: 0,
        getlonglat: null
    
    },
    reducers: {},
    extraReducers: builder => {
        builder
           
            .addCase(getBookingdetails.fulfilled, (state, action) => {
                 
                state.data = action.payload.data
            })

            .addCase(NextTypeID.fulfilled, (state, action) => {
                 
                state.JEventTypeID = action.payload
            })
            .addCase(getLongLat.fulfilled, (state, action) => {
               
              state.getlonglat = action.payload.data
             
              }) 

    }
})
export default DriverJourneySlice.reducer